import {TableSummary} from "./table-summary";

export class CustomGroupSummary {
    constructor(
        public readonly title?: string,
        public readonly order?: number,
        public readonly tables?: TableSummary[],
        public readonly totalAppliedPrice?: string,
        public readonly weeklyAppliedPrice?: string,
        public readonly monthlyAppliedPrice?: string
    ) {

    }


}
